import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function validatieStatusReducer(state = initialState.validatieStatussen, action) {
	switch (action.type) {
		case types.VALIDATIESTATUS_LOADED: {
			return action.body;
		}

		default:
			return state;
	}
}
